import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { StateProvider } from "./stateprovider";
import { reducer, initialState } from "./state";
import reportWebVitals from './reportWebVitals';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faBars, faX, faClose, faPerson, faArrowDown, faArrowUp, faArrowLeft, faEnvelope,faTrash  } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faFontAwesome, faGooglePlay } from '@fortawesome/free-brands-svg-icons'

library.add(fas, faTwitter, faFontAwesome, faBars, faX, faClose, faPerson, faArrowDown, faArrowUp, faArrowLeft, faEnvelope,faTrash)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <StateProvider initialState={initialState} reducer={reducer}>
    <App />
    </StateProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
